import React from 'react';
import styled from '@emotion/styled';
import { Flex } from '@qga/roo-ui/components';

import { BEST_RATE_TEXT } from '@shared/v2/constants/packages';

import Button from '@/components/Button';
import UnavailableWarning from '@/v2/components/pages/PackageViewV2/components/UnavailableWarning';
import useAlternativeOffer from '@/v2/components/pages/PackageViewV2/hooks/useAlternativeOffer';
import { Divider } from '@/v2/components/ui/Divider';
import RoomOptionDetails from '../../../../../RoomOptionDetails';

const FullWidthDivider = styled(Divider)`
  width: calc(100% + 2rem);
`;

const AlternativeOffer = () => {
  const {
    alternativeOffer,
    handleSelectAltOffer,
    alternativeOfferPackageOption,
  } = useAlternativeOffer() || {};
  const { offer, leadInOffer, roomType } = alternativeOffer || {};
  const isAltOfferAvailable = !!(offer && roomType);

  return (
    <Flex flexDirection="column" gap="6">
      <UnavailableWarning />
      {isAltOfferAvailable && (
        <>
          <Flex flexDirection="column" gap="4">
            <FullWidthDivider mx={-4} my={0} />
            <RoomOptionDetails
              title="Other package option"
              offer={{ ...offer, leadInOffer }}
              roomType={roomType}
              packageName={
                alternativeOfferPackageOption?.title ?? BEST_RATE_TEXT
              }
            />
          </Flex>
          <Button
            variant="primary"
            data-testid="PACKAGE_OPTION_CTA"
            block
            rounded
            outline
            onClick={handleSelectAltOffer}
          >
            Select package
          </Button>
        </>
      )}
    </Flex>
  );
};

export default AlternativeOffer;
